// Shared leave day-counting helpers. Mirrors the backend SQL functions
// count_working_days / count_leave_days so the UI and server agree.

// A plain 'YYYY-MM-DD' is that local day; new Date() would read it as UTC midnight, a day early west of Greenwich.
const toDay = (v) => new Date(/^\d{4}-\d{2}-\d{2}$/.test(v) ? `${v}T00:00:00` : v);

export function countWorkingDays(start, end) {
  if (!start || !end) return 0;
  const s = toDay(start);
  s.setHours(0, 0, 0, 0);
  const e = toDay(end);
  e.setHours(0, 0, 0, 0);
  if (e < s) return 0;
  let count = 0;
  for (let d = new Date(s); d <= e; d.setDate(d.getDate() + 1)) {
    const dow = d.getDay();
    if (dow !== 0 && dow !== 6) count += 1; // skip Sat (6) and Sun (0)
  }
  return count;
}

// Working days adjusted for half-day starts/ends. For a single-day request a
// half-day flag makes it 0.5; for multi-day, each flagged endpoint removes 0.5.
export function countLeaveDays(start, end, startHalf = false, endHalf = false) {
  const base = countWorkingDays(start, end);
  if (base === 0) return 0;
  const sameDay = toDay(start).toDateString() === toDay(end).toDateString();
  if (sameDay) return startHalf || endHalf ? 0.5 : base;
  return base - (startHalf ? 0.5 : 0) - (endHalf ? 0.5 : 0);
}

export function formatDays(value) {
  const num = Number(value) || 0;
  return Number.isInteger(num) ? `${num}` : num.toFixed(1);
}
